// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","canvas":"App_canvas__NaOQE"};